<template>
  <div class="appointment_item flex">
    <div class="appointment_item--main">
      <p class="appointment_item--main--line">
        {{ appointmentDate }} from {{ appointmentStartTime }} to {{ appointmentEndTime }}
      </p>
      <p class="appointment_item--main--info"><strong>Attendees:</strong> {{ attendees }}</p>
      <p class="appointment_item--main--info"><strong>Location:</strong> {{ appointment.location }}</p>

      <template v-if="appointment.description">
        <p class="appointment_item--main--info">
          <button-link
            @click="manageDescription"
          >
            {{ !isShowDescription ? 'show' : 'hide' }} description
          </button-link>
        </p>

        <div v-show="isShowDescription" class="appointment_item--main--description content mt-3 mb-0 ml-2" v-html="appointment.description"></div>
      </template>
    </div>

    <div class="appointment_item--record">
      <app-record
        :record="record"
        tooltip-position="is-left"
        include-fus-label
      ></app-record>
    </div>
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "UpNextAppointmentItem",
  props: {
    appointment: Object,
  },
  data() {
    return {
      isDisabled: false,
      isShowDescription: false
    }
  },
  computed: {
    record() {
      return this.appointment.record;
    },
    appointmentDate() {
      return dates.formatAsDate(this.appointment.start_at);
    },
    appointmentStartTime() {
      return dates.formatAsTime(this.appointment.start_at);
    },
    appointmentEndTime() {
      return dates.formatAsTime(this.appointment.end_at);
    },
    attendees() {
      const attendees = this.appointment.attendees.map(a => a.full_name);
      const string = attendees.join(', ');

      if (string === ' ') {
        return 'n/a';
      }

      return string;
    },
  },
  methods: {
    manageDescription() {
      console.log('before', this.isShowDescription)
      this.isShowDescription = !this.isShowDescription
      console.log('after', this.isShowDescription)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.appointment_item {
  padding: 10px;
  background-color: $white;
  border-bottom: 1px solid $border;

  &--main {
    flex-grow: 1;

    &--line {
      font-size: 1.25rem;
      font-weight: bold;
    }

    &--info {
      margin-top: 0.5rem;
    }

    &--description {
      width: 100%;
      word-wrap: break-word;
      overflow: hidden;
    }
  }

  &--record {
    flex: 0 0 360px;
  }

  &:hover {
    background-color: $background;
  }

  @include mobile {
    flex-wrap: wrap;
    margin-bottom: 12px;
    border-bottom: 0;

    &--main {
      padding-bottom: 8px;
      border-bottom: 1px solid $border;

      &--line {
        font-size: 1rem;
      }

      &--info {
        font-size: 0.75rem;
      }
    }

    &--record {
      flex-basis: 100%;
      margin-top: 8px;
    }

    &:hover {
      background-color: inherit;
    }
  }
}
</style>
